export default __webpack_public_path__ + "static/media/Logo-Lehigh-Hanson-09-07-58-089.73534d0c.svg";